import React from "react";
import DisplayMaster from '../DisplayMaster';

export default function WarmianMasurian() {
  return (
    <>
      <DisplayMaster voivodeship="WarmianMasurian" />
    </>
  );
}